import type { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form'

// The plumbing every `*-fields.ts` needs and none of them owns. Where the boundary with the
// app half runs, and why: README.

/** True when there is nothing to send: the Save button stays off. */
export function isEmptyPatch(body: object): boolean {
  return Object.keys(body).length === 0
}

/** Spreads the server's errors over the fields they concern; `form` goes to the Alert.
 * Keyed on the form's own fields, because a `setError` on a name with no input loses the
 * message in silence. */
export function applyFieldErrors<TFields extends FieldValues>(
  form: UseFormReturn<TFields>,
  errors: Readonly<Partial<Record<(keyof TFields & string) | 'form', string>>>,
): void {
  for (const [field, text] of Object.entries(errors)) {
    if (field === 'form' || text === undefined) continue
    form.setError(field as FieldPath<TFields>, { message: text })
  }
}

/** Puts the missing-field errors on the form and answers whether to stop the submit.
 * `clearErrors` first, or a field corrected since the last attempt stays red. The one
 * client check worth having: the server answers «Troppo corto: almeno 1 caratteri». */
export function applyMissingRequired<TFields extends FieldValues>(
  form: UseFormReturn<TFields>,
  missing: Readonly<Partial<Record<(keyof TFields & string) | 'form', string>>>,
): boolean {
  form.clearErrors()
  applyFieldErrors(form, missing)
  return !isEmptyPatch(missing)
}
